// Property detail query keys factory.
// Mutations invalidate via the factory only — never raw arrays.

export const propertyKeys = {
  all: ['property'] as const,
  details: () => [...propertyKeys.all, 'detail'] as const,
  detail: (id: string) => [...propertyKeys.details(), id] as const,
}
